import { hasDossierAmo } from "../utils/tenantProfile";

// LOT B — widgets 100 % AMO (ils lisent des données de visites/honoraires AMO) : NON montés
// quand le tenant ne déclare pas la capacité « dossier AMO » (masqués, pas renommés).
export const WIDGETS_AMO = new Set([
  "finance_kpis", "finance_pipeline", "finance_visites_amo", "finance_visites_suivi",
]);
export function widgetMonte(id) {
  return !WIDGETS_AMO.has(id) || hasDossierAmo();
}
